import type { JSX } from "solid-js";
import {
	type Toast,
	type ToastPosition,
	type ToastType,
	toastStore,
} from "./toastStore.ts";

type ToastOptions = {
	title: string;
	/** Material Symbol name; overrides the default for the toast type. */
	symbol?: string;
	/** Material Symbol fill. Defaults to filled. */
	filled?: boolean;
	description?: string | (({ toast, handleClose }: { toast: Toast, handleClose: () => void }) => JSX.Element);
	duration?: number;
	position?: ToastPosition;
	store?: boolean;
	/** Persisted notification body when `description` is a component (not a string). */
	storeDescription?: string;
	/** Notification type in the panel when `store` is true (defaults to toast type). */
	storeType?: ToastType;
	revert_action?: Record<string, unknown>;
};

export const toast = {
	success: (options: ToastOptions) => {
		toastStore.addToast({
			type: "success",
			active: true,
			...options,
		});
	},
	info: (options: ToastOptions) => {
		toastStore.addToast({
			type: "info",
			active: true,
			...options,
		});
	},
	warning: (options: ToastOptions) => {
		toastStore.addToast({
			type: "warning",
			active: true,
			store: true,
			...options,
		});
	},
	error: (options: ToastOptions) => {
		toastStore.addToast({
			type: "error",
			active: true,
			store: true,
			...options,
		});
	},
};

export type { Toast, ToastPosition, ToastType } from "./toastStore";
